import React from 'react';
import './Solutions.css';
import { useNavigate } from 'react-router-dom';
import PurpleButton from '../common/PurpleButton/PurpleButton';

const Solutions = ({ title, subtitle, cards }) => {
  const navigate = useNavigate();

  const handleCardClick = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <section className="solutions container">
      {/* <div className="solutions-header">
        <span className="subtitle">{subtitle}</span>
        <h2>{title}</h2>
      </div> */}
      <div className="solutions-grid">
        {cards.map((card, index) => (
          <div 
            key={index} 
            className="solution-card" 
          >
            <div className="solution-icon">
              {card.icon}
            </div>
            <h3>{card.title}</h3>
            <p>{card.description}</p>
            <div className="solution-button">
              <PurpleButton text="了解更多" onClick={() => handleCardClick(card.path)} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Solutions; 